import React from 'react'
import { IconPropsType } from '../types'

const EyeOffIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      className={className}
    >
      <path
        d='M1.39932 1.89923C1.23146 2.06708 1.2162 2.32976 1.35354 2.51485L1.39932 2.56788L3.94277 5.11133C2.73112 5.96206 1.82554 7.2327 1.44925 8.7359C1.38584 8.98921 1.53979 9.24596 1.7931 9.30937C2.04641 9.37278 2.30316 9.21884 2.36657 8.96553C2.70036 7.6321 3.52473 6.51374 4.62357 5.79195L5.76439 6.93283C5.31836 7.38769 5.04333 8.01084 5.04333 8.69823C5.04333 10.0909 6.17231 11.2199 7.56499 11.2199C8.25237 11.2199 8.87552 10.9449 9.33039 10.4988L13.062 14.2306C13.2466 14.4152 13.546 14.4152 13.7307 14.2306C13.8985 14.0627 13.9138 13.8 13.7764 13.6149L13.7307 13.5619L9.87659 9.70743L9.87735 9.7065L5.49645 5.32752L5.49722 5.32637L4.78278 4.61368L2.06797 1.89923C1.88333 1.71458 1.58396 1.71458 1.39932 1.89923ZM7.56499 3.9672C6.93441 3.9672 6.32253 4.06054 5.74378 4.23512L6.52358 5.01444C6.86136 4.94769 7.20968 4.91282 7.56499 4.91282C10.0381 4.91282 12.1733 6.6025 12.7641 8.96837C12.8274 9.22172 13.084 9.37581 13.3374 9.31254C13.5907 9.24927 13.7448 8.9926 13.6816 8.73925C12.9862 5.95472 10.4747 3.9672 7.56499 3.9672ZM7.68772 6.1795L10.0841 8.57553C10.02 7.27882 8.98168 6.24151 7.68772 6.1795Z'
        fill='white'
      />
    </svg>
  )
}

export default EyeOffIcon
